<!-- youtube-desktop-01 preview — YouTube in-stream (desktop) -->
<app-desktop-frame>
  <!-- START: Watch page -->
  <div class="ytv-isd-page d-flex flex-column">
    <div class="ytv-isd-header">
      <app-youtube-navbar></app-youtube-navbar>
    </div>

    <div class="ytv-isd-body d-flex flex-row">
      <!-- START: Watch column -->
      <div class="ytv-isd-primary">
        <!-- START: Player running the ad -->
        <div class="ytv-isd-player">
          <img
            *ngIf="thumbnailUrl; else noCreative"
            class="ytv-isd-creative"
            [src]="thumbnailUrl"
            alt=""
          />

          <ng-template #noCreative>
            <div class="ytv-isd-creative creative-missing">
              <ng-container *ngIf="isResolving; else askForVideo">
                Reading video format&hellip;
              </ng-container>
              <ng-template #askForVideo>
                Add a video to see this preview
              </ng-template>
            </div>
          </ng-template>

          <!-- Player chrome. Fixed copy where it is the ad's frame, not the
               author's. Only drawn over a creative — it is white on the grey
               empty slot. -->
          <ng-container *ngIf="thumbnailUrl">
            <div class="ytv-isd-overlay d-flex flex-row align-items-center">
              <img
                class="ytv-isd-overlay-logo"
                src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
                alt=""
              />
              <div class="ytv-isd-overlay-text">
                <div class="ytv-isd-overlay-headline">{{ headline }}</div>
                <div class="ytv-isd-overlay-url">{{ displayUrl }}</div>
              </div>
              <a
                class="ytv-isd-overlay-cta"
                [href]="data.url"
                target="_blank"
                rel="noopener noreferrer"
                >{{ ctaText }}</a
              >
            </div>

            <span class="ytv-isd-skip"
              >Skip Ad <i class="bi bi-skip-end-fill"></i
            ></span>
            <span class="ytv-isd-countdown">00:16</span>
          </ng-container>
        </div>

        <!-- A yellow progress bar is what marks the player as running an ad. -->
        <div class="ytv-isd-controls">
          <div class="ytv-isd-progress"><span class="ytv-isd-progress-fill"></span></div>
          <div class="ytv-isd-buttons d-flex flex-row align-items-center">
            <i class="bi bi-pause-fill"></i>
          </div>
        </div>
        <!-- END: Player -->

        <!-- The watch page under the player, stubbed out: the ad is the subject. -->
        <span class="ytv-isd-title placeholder"></span>
        <div class="ytv-isd-channel d-flex flex-row">
          <span class="ytv-isd-avatar placeholder"></span>
          <div class="ytv-isd-channel-text d-flex flex-column">
            <span class="ytv-isd-bar ytv-isd-bar-lead placeholder"></span>
            <span class="ytv-isd-bar ytv-isd-bar-sub placeholder"></span>
          </div>
        </div>

        <div class="ytv-isd-comments d-flex flex-column">
          <div
            class="ytv-isd-comment d-flex flex-row"
            *ngFor="let row of commentRows"
          >
            <span class="ytv-isd-avatar ytv-isd-comment-avatar placeholder"></span>
            <div class="ytv-isd-channel-text d-flex flex-column">
              <span class="ytv-isd-bar ytv-isd-bar-sub placeholder"></span>
              <span class="ytv-isd-bar ytv-isd-bar-lead placeholder"></span>
            </div>
          </div>
        </div>
      </div>
      <!-- END: Watch column -->

      <!-- START: Sidebar -->
      <div class="ytv-isd-secondary">
        <!-- START: Companion banner — the same creative, cropped to a strip -->
        <a
          [href]="data.url"
          target="_blank"
          rel="noopener noreferrer"
          class="ytv-isd-banner-link"
        >
          <img
            *ngIf="thumbnailUrl; else emptyBanner"
            class="ytv-isd-banner"
            [src]="thumbnailUrl"
            alt=""
          />
          <ng-template #emptyBanner>
            <span class="ytv-isd-banner"></span>
          </ng-template>
        </a>

        <div class="ytv-isd-card d-flex flex-row align-items-center">
          <img
            class="ytv-isd-card-logo"
            src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
            alt=""
          />
          <div class="ytv-isd-card-text">
            <div class="ytv-isd-card-headline">{{ headline }}</div>
            <div class="ytv-isd-card-meta">
              <span class="ytv-isd-card-label">Sponsored</span> &middot;
              {{ displayUrl }}
            </div>
          </div>
          <a
            class="ytv-isd-card-cta"
            [href]="data.url"
            target="_blank"
            rel="noopener noreferrer"
            >{{ ctaText }}</a
          >
        </div>
        <!-- END: Companion banner -->

        <!-- The up-next list, stubbed: identical rows, so one loop. -->
        <div class="ytv-isd-up-next d-flex flex-column">
          <div
            class="ytv-isd-up-row d-flex flex-row"
            *ngFor="let row of upNextRows"
          >
            <span class="ytv-isd-up-thumb placeholder"></span>
            <div class="ytv-isd-up-text d-flex flex-column">
              <span class="ytv-isd-up-title placeholder"></span>
              <span class="ytv-isd-up-line ytv-isd-up-line-lead placeholder"></span>
              <span class="ytv-isd-up-line ytv-isd-up-line-sub placeholder"></span>
            </div>
          </div>
        </div>
      </div>
      <!-- END: Sidebar -->
    </div>
  </div>
  <!-- END: Watch page -->
</app-desktop-frame>
